<!-- 分包加单 -->
<template>
<el-dialog :title="msg('分包加单')" 
    :visible.sync="visible" 
    :fullscreen="isMinScreen"  
    :close-on-click-modal="false" 
    width="600px"
>
    <el-form label-width="100px">
        <el-row>
            <el-col :xs="24" :sm="20">
                <el-form-item :label="msg('订单编号')">
                    <el-input v-model="code" placeholder="请输入订单编号" size="small"></el-input>
                </el-form-item>
                <el-form-item :label="msg('加单数')">
                    <el-input v-model="count" type="number" placeholder="请输入加单数" size="small"></el-input>
                </el-form-item>
                <el-form-item :label="msg('')">
                    <el-checkbox v-model="checked">复制备货单号</el-checkbox>
                </el-form-item>
            </el-col>
        </el-row>
    
        <div style="text-align:center;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button  size="mini" v-on:click="close">{{msg('取消')}}</el-button>
        </div>
    </el-form> 
</el-dialog>
</template>

<script>
export default {
  name: 'ExpAddPkg',
  data(){
        return{
            code:null,
            count:0,
            visible: false,
            checked:false,
        }
    }, 
    computed:{
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    methods:{
        showDialog(){
            this.code = null;
            this.count = 0;
            this.visible = true;
            this.checked = false;
        },
        onSubmit(){
            var _this = this;

            if(!this.code || this.count <= 0){
                this.$message(this.msg('请输入订单编号和数量'));
                return;
            }

            this.$axios.post(this.$kit.api.stock.stockAddPkg
                +"?code="+this.code
                +"&count="+this.count
                +"&copy="+this.checked
            ).then((result) =>{
                _this.$message(result.msg);
                if(result.status){
                    _this.$emit("finish",true);
                    _this.code = null;
                    _this.count = 0;
                }
            });
        },
        close(){
            this.visible = false;
            this.$emit('finish')
        }
    }
}
</script>

<style scoped lang="scss">


</style>
